  const radii = {
    defaultOnsiteWarn: 250,
    defaultOnsiteBlock: 100000,
    defaultOffsiteWarn: 250,
    defaultOffsiteBlock: 100000,
  }
  const OffsiteJobTypeIds = [
    7,    //Delivery & Pickup
    8,    //Truck Driver
    13    //Driver
  ];
  const isJobOffsite = (jobTypeId) => {
    return OffsiteJobTypeIds.includes(jobTypeId);
  }
  const getCompanyRadii = (company) => {
    return {
      onsiteWarnRadius: toMetric(company.min_onsite_warn_radius ? company.min_onsite_warn_radius : radii.defaultOnsiteWarn),
      onsiteBlockRadius: toMetric(company.min_onsite_block_radius ? company.min_onsite_block_radius : radii.defaultOnsiteBlock),
      offsiteWarnRadius: toMetric(company.min_offsite_warn_radius ? company.min_offsite_warn_radius : radii.defaultOffsiteWarn),
      offsiteBlockRadius: toMetric(company.min_offsite_block_radius ? company.min_offsite_block_radius : radii.defaultOffsiteBlock),
      onsiteWarnMeasure: toMeasure(company.min_onsite_warn_radius ? company.min_onsite_warn_radius : radii.defaultOnsiteWarn),
      onsiteBlockMeasure: toMeasure(company.min_onsite_block_radius ? company.min_onsite_block_radius : radii.defaultOnsiteBlock),
      offsiteWarnMeasure: toMeasure(company.min_offsite_warn_radius ? company.min_offsite_warn_radius : radii.defaultOffsiteWarn),
      offsiteBlockMeasure: toMeasure(company.min_offsite_block_radius ? company.min_offsite_block_radius : radii.defaultOffsiteBlock),
      onsiteWarnStep: toStep(company.min_onsite_warn_radius ? company.min_onsite_warn_radius : radii.defaultOnsiteWarn),
      onsiteBlockStep: toStep(company.min_onsite_block_radius ? company.min_onsite_block_radius : radii.defaultOnsiteBlock),
      offsiteWarnStep: toStep(company.min_offsite_warn_radius ? company.min_offsite_warn_radius : radii.defaultOffsiteWarn),
      offsiteBlockStep: toStep(company.min_offsite_block_radius ? company.min_offsite_block_radius : radii.defaultOffsiteBlock),
    };
  }
  const setCompanyRadii = (radii, company) => {
    company.min_onsite_warn_radius = toMeters(radii.onsiteWarnRadius, radii.onsiteWarnMeasure);
    company.min_onsite_block_radius = toMeters(radii.onsiteBlockRadius, radii.onsiteBlockMeasure);
    company.min_offsite_warn_radius = toMeters(radii.offsiteWarnRadius, radii.offsiteWarnMeasure);
    company.min_offsite_block_radius = toMeters(radii.offsiteBlockRadius, radii.offsiteBlockMeasure);
  }
  const defaultPositionRadii = (position) => {
    if (position.site_designation == 'UNKNOWN') {
        position.site_designation = isJobOffsite(position.job_type) ? "OFFSITE" : "ONSITE"
    }
    if (!position.min_warn_radius) {
        position.min_warn_radius = isJobOffsite(position.job_type) ? radii.defaultOffsiteWarn : radii.defaultOnsiteWarn
    }
    if (!position.min_block_radius) {
        position.min_block_radius = isJobOffsite(position.job_type) ? radii.defaultOffsiteBlock : radii.defaultOnsiteBlock
    }
  }
  const toMetric = (val) => {
      return (val > 999) ? toKilometers(val) : val;
  }
  const toMeasure = (val) => {
      return (val > 999) ? 'kilometers' : 'meters';
  }
  const toStep = (val) => {
      return (val > 999) ? 0.1 : 1;
  }
  const toKilometers = (val) => {
    return parseFloat((val / 1000).toFixed(1));
  }
  const toMeters = (val, measure) => {
    return measure === 'meters' ? val : val * 1000;
  }

export { getCompanyRadii, setCompanyRadii, defaultPositionRadii, isJobOffsite, toKilometers, toMetric }
